import delivery from './delivery.svg';

export const images = { delivery };
